import React from 'react'
import FlipSwitch from '../AppDetail/FlipSwitch'
import './projectForm.css'
import ProjectUtils from './ProjectUtils'
import { useEffect } from 'react'

export function ProjectCreationForm(props) {
  const errorComponent = () => {
    const navigatehere = () => {
      const spaceId = props.projectCreationError &&
        props.projectCreationError.payload &&
        props.projectCreationError.payload.response &&
        props.projectCreationError.payload.response.space &&
        props.projectCreationError.payload.response.space.id ?
        props.projectCreationError.payload.response.space.id : null

      const spaceName = props.projectCreationError &&
        props.projectCreationError.payload &&
        props.projectCreationError.payload.response &&
        props.projectCreationError.payload.response.space &&
        props.projectCreationError.payload.response.space.title ?
        props.projectCreationError.payload.response.space.title : null

      if (spaceId && spaceName) {
        props.checkToProject(spaceId, spaceName)
      } else {
        window.location = `/`
      }
    }

    const conflictError = props.projectCreationError &&
      props.projectCreationError.payload &&
      props.projectCreationError.payload.status === 412 &&
      props.projectCreationError.payload.response &&
      props.projectCreationError.payload.response.message &&
      props.projectCreationError.payload.response.message.includes('already exists') ? true : false

    if (!props.projectCreationError) return <></>

    if (!conflictError && props.projectCreationError && props.projectCreationError.payload && props.projectCreationError.payload.response && props.projectCreationError.payload.response.message) {
      return (
        <div className="error-flow-t-div">
          <span>{props.projectCreationError.payload.response.message}</span>
        </div>
      )
    }
    else {
      return (
        <div className="error-flow-t-div">
          <span>A flow with this name already exists. <a href='#' onClick={(e) => { e.preventDefault(); navigatehere() }}>navigate here</a> to the existing flow or try updating the flow name.</span>
        </div>
      )
    }
  }

  useEffect(() => {
    return () => {
      if (props.updateProjectCreationError) {
        props.updateProjectCreationError(null)
      }
    }
  }, [])

  return (
    <div className="em-row project-cr-form">
      <div className="em-row">
        {errorComponent()}
      </div>
      <div className="em-row project-creation-form">
        <label htmlFor="text_input">Name</label>
        <input
          type="text"
          id="text_input"
          name="text_input"
          placeholder=""
          value={props.textInput}
          onChange={props.handleTextInputChange}
          disabled={!props.isBuild ? true : false}
          required

        />
        <label htmlFor="text_input">Description</label>
        <textarea
          id="description"
          name="description"
          rows="4"
          cols="50"
          placeholder=""
          value={props.description}
          onChange={props.handleDescriptionChange}
          disabled={!props.isBuild ? true : false}
        ></textarea>
        {props.flowId !== 'blank_project' && props.isBuild && (
          <label className="text_input-hint">
            Please note you can modify the above fields according to your requirements.
          </label>
        )}
      </div>
      {props.getAllGroups !== null &&
        <div className="em-row em-flex group-info">
          {!props.isBuild && (
            <>
              <div className="em-row f-switch">
                <FlipSwitch
                  handleHideErrorIter={value => {
                    if (value === false) {
                      props.setGroupId('')
                    }
                    props.setShowAdvanced(value)
                  }}
                  label="Group Invite"
                  graph={true}
                />
              </div>
              {props.showAdvanced && (
                <div className="em-row projectutils group-sets">
                  <ProjectUtils userGroups={props.getAllGroups()} setGroupId={value => props.setGroupId(value)} refreshGroups={props.refreshGroups} />
                  <button
                    onClick={() => {
                      props.refreshGroups()
                    }}
                    className="group-refresh-button"
                  >
                    <i class="fa fa-refresh i-action"></i>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      }
      <div className="em-row" style={{ marginTop: 20, display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button
          className={'project-button em-danger ufont'}
          style={{ border: 'none' }}
          onClick={() => {
            props.setProjectPopup()
          }}
        >
          Cancel
        </button>
        <button
          className={
            props.textInput !== null ? 'em-btn project-button ufont' : 'em-btn project-button-continue-disabled ufont'
          }
          onClick={() => {
            if (props.textInput !== '') {
              props.createNewRecord()
            } else {
              props.IsEmpty()
            }
          }}
        >
          Create
        </button>
      </div>
    </div>
  )
}
